import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import { queryBuilder } from '@wix/sdk-runtime/query-builder';
import { renameKeysFromSDKRequestToRESTRequest, renameKeysFromRESTResponseToSDKResponse, } from '@wix/sdk-runtime/rename-all-nested-keys';
import * as ambassadorWixEcomV1LocalDeliveryOption from './ecom-v1-local-delivery-option-local-delivery-options.http.js';
// @ts-ignore
import { transformSDKAddressToRESTAddress } from '@wix/sdk-runtime/transformations/address';
import { transformRESTAddressToSDKAddress } from '@wix/sdk-runtime/transformations/address';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
export var LengthUnit;
(function (LengthUnit) {
    /** Length unit can't be classified, due to an error */
    LengthUnit["UNSPECIFIED_LENGTH_UNIT"] = "UNSPECIFIED_LENGTH_UNIT";
    /** Kilometers */
    LengthUnit["KM"] = "KM";
    /** Miles */
    LengthUnit["MI"] = "MI";
})(LengthUnit || (LengthUnit = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    /** Monday. */
    DayOfWeek["MON"] = "MON";
    /** Tuesday. */
    DayOfWeek["TUE"] = "TUE";
    /** Wednesday. */
    DayOfWeek["WED"] = "WED";
    /** Thursday. */
    DayOfWeek["THU"] = "THU";
    /** Friday. */
    DayOfWeek["FRI"] = "FRI";
    /** Saturday. */
    DayOfWeek["SAT"] = "SAT";
    /** Sunday. */
    DayOfWeek["SUN"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
export var ConditionType;
(function (ConditionType) {
    ConditionType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ConditionType["BY_TOTAL_WEIGHT"] = "BY_TOTAL_WEIGHT";
    ConditionType["BY_TOTAL_PRICE"] = "BY_TOTAL_PRICE";
    ConditionType["BY_TOTAL_QUANTITY"] = "BY_TOTAL_QUANTITY";
})(ConditionType || (ConditionType = {}));
export var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["UNKNOWN_LOGICAL_OPERATOR_TYPE"] = "UNKNOWN_LOGICAL_OPERATOR_TYPE";
    LogicalOperator["EQ"] = "EQ";
    LogicalOperator["GT"] = "GT";
    LogicalOperator["GTE"] = "GTE";
    LogicalOperator["LT"] = "LT";
    LogicalOperator["LTE"] = "LTE";
})(LogicalOperator || (LogicalOperator = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
/** @public
 * @documentationMaturity preview
 * @requiredField localDeliveryOption
 * @requiredField localDeliveryOption.areaName
 * @requiredField localDeliveryOption.radiusConfig.address
 * @requiredField localDeliveryOption.radiusConfig.address.formatted
 * @requiredField localDeliveryOption.radiusConfig.address.location
 * @requiredField localDeliveryOption.rate
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.handlingDays
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_CREATE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.CreateLocalDeliveryOption
 */
export async function createLocalDeliveryOption(localDeliveryOption) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        localDeliveryOption: localDeliveryOption,
    }), [
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'localDeliveryOption.radiusConfig.address' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.createLocalDeliveryOption(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOption.radiusConfig.address' }],
            },
        ]))?.localDeliveryOption;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { localDeliveryOption: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['localDeliveryOption']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField localDeliveryOptionId
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_READ
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.GetLocalDeliveryOption
 */
export async function getLocalDeliveryOption(localDeliveryOptionId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        localDeliveryOptionId: localDeliveryOptionId,
        id: options?._id,
    });
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.getLocalDeliveryOption(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOption.radiusConfig.address' }],
            },
        ]))?.localDeliveryOption;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                localDeliveryOptionId: '$[0]',
                id: '$[1]._id',
            },
            singleArgumentUnchanged: false,
        }, ['localDeliveryOptionId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField externalId
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_READ
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.ListLocalDeliveryOptions
 * @deprecated method is deprecated due to the fact that external_id is deprecated
 * @replacedBy ListLocalDeliveryOptionsByDeliveryRegion
 * @targetRemovalDate 2024-11-01
 */
export async function listLocalDeliveryOptions(externalId) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        externalId: externalId,
    });
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.listLocalDeliveryOptions(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOptions.radiusConfig.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { externalId: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['externalId']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a list of local delivery options, given the provided paging, filtering, and sorting.
 *
 * For field support for filters and sorting, see [Local Delivery: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-regions/supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @public
 * @documentationMaturity preview
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_READ
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.QueryLocalDeliveryOptions
 */
export function queryLocalDeliveryOptions() {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[0];
    return queryBuilder({
        func: async (payload) => {
            const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.queryLocalDeliveryOptions(payload);
            sideEffects?.onSiteCall?.();
            try {
                const result = await httpClient.request(reqOpts);
                sideEffects?.onSuccess?.(result);
                return result;
            }
            catch (err) {
                sideEffects?.onError?.(err);
                throw err;
            }
        },
        requestTransformer: (query) => {
            const args = [query, {}];
            return renameKeysFromSDKRequestToRESTRequest({
                ...args?.[1],
                query: args?.[0],
            });
        },
        responseTransformer: ({ data, }) => {
            const transformedData = renameKeysFromRESTResponseToSDKResponse(transformPaths(data, [
                {
                    transformFn: transformRESTAddressToSDKAddress,
                    paths: [{ path: 'localDeliveryOptions.radiusConfig.address' }],
                },
            ]));
            return {
                items: transformedData?.localDeliveryOptions,
                pagingMetadata: transformedData?.pagingMetadata,
            };
        },
        errorTransformer: (err) => {
            const transformedError = sdkTransformError(err, {
                spreadPathsToArguments: {},
                explicitPathsToArguments: { query: '$[0]' },
                singleArgumentUnchanged: false,
            });
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: {},
    });
}
/** @param _id - LocalDeliveryOptionId - unique identifier of local delivery option
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField localDeliveryOption
 * @requiredField localDeliveryOption.radiusConfig.address
 * @requiredField localDeliveryOption.radiusConfig.address.formatted
 * @requiredField localDeliveryOption.radiusConfig.address.location
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.friday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.saturday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.sunday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.thursday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.tuesday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.enabledForDelivery
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.from
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.from.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.from.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.to
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.to.hours
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.days.wednesday.timeSlots.to.minutes
 * @requiredField localDeliveryOption.scheduledDeliveryConfig.handlingDays
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_UPDATE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.UpdateLocalDeliveryOption
 */
export async function updateLocalDeliveryOption(_id, localDeliveryOption) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        localDeliveryOption: { ...localDeliveryOption, id: _id },
    }), [
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'localDeliveryOption.radiusConfig.address' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.updateLocalDeliveryOption(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOption.radiusConfig.address' }],
            },
        ]))?.localDeliveryOption;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: { localDeliveryOption: '$[1]' },
            explicitPathsToArguments: { 'localDeliveryOption.id': '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id', 'localDeliveryOption']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField localDeliveryOptionId
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_DELETE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.DeleteLocalDeliveryOption
 */
export async function deleteLocalDeliveryOption(localDeliveryOptionId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        localDeliveryOptionId: localDeliveryOptionId,
        id: options?._id,
    });
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.deleteLocalDeliveryOption(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                localDeliveryOptionId: '$[0]',
                id: '$[1]._id',
            },
            singleArgumentUnchanged: false,
        }, ['localDeliveryOptionId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField localDeliveryOptions
 * @requiredField localDeliveryOptions.radiusConfig.address
 * @requiredField localDeliveryOptions.radiusConfig.address.formatted
 * @requiredField localDeliveryOptions.radiusConfig.address.location
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.handlingDays
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_CREATE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.BulkCreateLocalDeliveryOption
 */
export async function bulkCreateLocalDeliveryOption(localDeliveryOptions) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        localDeliveryOptions: localDeliveryOptions,
    }), [
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'localDeliveryOptions.radiusConfig.address' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.bulkCreateLocalDeliveryOption(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOptions.radiusConfig.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { localDeliveryOptions: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['localDeliveryOptions']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField localDeliveryOptions
 * @requiredField localDeliveryOptions.radiusConfig.address
 * @requiredField localDeliveryOptions.radiusConfig.address.formatted
 * @requiredField localDeliveryOptions.radiusConfig.address.location
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.friday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.monday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.saturday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.sunday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.thursday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.tuesday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.enabledForDelivery
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.from
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.from.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.from.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.to
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.to.hours
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.days.wednesday.timeSlots.to.minutes
 * @requiredField localDeliveryOptions.scheduledDeliveryConfig.handlingDays
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_UPDATE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.BulkUpdateLocalDeliveryOption
 */
export async function bulkUpdateLocalDeliveryOption(localDeliveryOptions) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        localDeliveryOptions: localDeliveryOptions,
    }), [
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'localDeliveryOptions.radiusConfig.address' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.bulkUpdateLocalDeliveryOption(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOptions.radiusConfig.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { localDeliveryOptions: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['localDeliveryOptions']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField ids
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_DELETE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.BulkDeleteLocalDeliveryOption
 */
export async function bulkDeleteLocalDeliveryOption(ids) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ ids: ids });
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.bulkDeleteLocalDeliveryOption(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { ids: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['ids']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField deliveryRegionId
 * @requiredField options.localDeliveryOptionId
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_UPDATE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.AddDeliveryRegion
 */
export async function addDeliveryRegion(deliveryRegionId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        deliveryRegionId: deliveryRegionId,
        localDeliveryOptionId: options?.localDeliveryOptionId,
        revision: options?.revision,
    });
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.addDeliveryRegion(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOption.radiusConfig.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                deliveryRegionId: '$[0]',
                localDeliveryOptionId: '$[1].localDeliveryOptionId',
                revision: '$[1].revision',
            },
            singleArgumentUnchanged: false,
        }, ['deliveryRegionId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/** @public
 * @documentationMaturity preview
 * @requiredField deliveryRegionId
 * @requiredField options.localDeliveryOptionId
 * @permissionId ECOM.LOCAL_DELIVERY_OPTION_UPDATE
 * @fqn com.wix.ecom.shipments.localdelivery.LocalDelivery.RemoveDeliveryRegion
 */
export async function removeDeliveryRegion(deliveryRegionId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        deliveryRegionId: deliveryRegionId,
        localDeliveryOptionId: options?.localDeliveryOptionId,
        revision: options?.revision,
    });
    const reqOpts = ambassadorWixEcomV1LocalDeliveryOption.removeDeliveryRegion(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'localDeliveryOption.radiusConfig.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                deliveryRegionId: '$[0]',
                localDeliveryOptionId: '$[1].localDeliveryOptionId',
                revision: '$[1].revision',
            },
            singleArgumentUnchanged: false,
        }, ['deliveryRegionId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
//# sourceMappingURL=ecom-v1-local-delivery-option-local-delivery-options.universal.js.map